import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheMasterpieceHero from "./sections/TheMasterpieceHero";
import ImpactStories from "./sections/ImpactStories";
import ThreeSimpleSteps from "./sections/ThreeSimpleSteps";
import ExpertSolutionsForEveryPipe from "./sections/ExpertSolutionsForEveryPipe";
import TheCraftsmansStandard from "./sections/TheCraftsmansStandard";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import StartYourProject from "./sections/StartYourProject";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheMasterpieceHero />
      <ImpactStories />
      <ThreeSimpleSteps />
      <ExpertSolutionsForEveryPipe />
      <TheCraftsmansStandard />
      <ClientSuccessStories />
      <StartYourProject />
      <GamingSocialFooter />
    </div>;
}